import React, { Component } from 'react'
import PropTypes from 'prop-types';

import { checkDate } from '../../../utils/formatting';
import { getMediaUrl } from '../../../utils/routing';

import LinesClamp from '../../LinesClamp/LinesClamp';

import './MediaElement.css'

export default class MediaElement extends Component {
    static propTypes = {
        videoId: PropTypes.string,
        title: PropTypes.string,
        videoUrl: PropTypes.string,
        link: PropTypes.string,
        publishedAt: PropTypes.string,
    }

    renderCover() {
        //const dataVideoUrl = 'https://www.youtube.com/embed/'+this.props.videoId+'/?autoplay=1&hl=ru&rel=0' // {item.video_url}
        const img_src = 'https://i.ytimg.com/vi/'+this.props.videoId+'/maxresdefault.jpg' //'https://img.youtube.com/vi/'+this.props.videoId+'/maxresdefault.jpg'

        return img_src ? (
            <>
            <span className="MediaEl_cover" style={{backgroundImage: `url(${img_src})`,}}></span>
            <span className='small-news_play'></span>
            </>
        ) : (
            <div className="MediaEl_cover" />
        )
    }

    render() {
        // {this.props.videoUrl} target="_blank" 
        return (
            <div className="MediaEl_base">
                <div className="ev_click-mediael"></div>
                <div className="ev_click-tag-on-mediael"></div>
                <a className="MediaEl_inner" href={getMediaUrl(this.props.link)} rel="noreferrer">
                    <div className="MediaEl_header">
                        {this.renderCover()}
                        {/* <span className="MediaEl_cover__img" data-bind="text: label">Подробнее</span> */}
                    </div>
                    <div className="MediaEl_body">
                        <div className="MediaEl_title" title={this.props.title}>
                            <LinesClamp
                                text={this.props.title}
                                className="MediaEl_clampLines"
                                lines={2}
                            />
                        </div>
                        <div className="MediaEl_summary">
                            <div className="MediaEl-date">
                                <span>Опубликовано: </span>
                                <span>{ checkDate(this.props.publishedAt) }</span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        )
    }
}